import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  quote: string;
  text: string;
  name: string;
  age: number;
  image: string;
}
interface TestimonialSectionProps {
  heading?: string;
  testimonials: Testimonial[];
}
export function TestimonialSection({
  heading,
  testimonials
}: TestimonialSectionProps) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-12 md:py-20 bg-white" data-id="element-248">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249">
        {heading && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-250">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-deep-charcoal" data-id="element-251">
              {heading}
            </h2>
          </motion.div>}

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className={`grid grid-cols-1 ${testimonials.length === 1 ? 'max-w-3xl mx-auto' : testimonials.length === 2 ? 'md:grid-cols-2 max-w-5xl mx-auto' : 'md:grid-cols-3'} gap-6 md:gap-8`} data-id="element-252">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="bg-cream-white rounded-2xl p-6 md:p-8 border border-warm-beige shadow-sm" data-id="element-253">
              <div className="flex items-center gap-4 mb-5" data-id="element-254">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2 border-sage-green/20" data-id="element-255" />
                <div data-id="element-256">
                  <div className="flex gap-1 mb-2" data-id="element-257">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-dusty-rose text-dusty-rose" data-id="element-258" />)}
                  </div>
                  <p className="text-sm font-semibold text-deep-charcoal" data-id="element-259">
                    {testimonial.name}, {testimonial.age} años
                  </p>
                </div>
              </div>

              <h3 className="text-lg md:text-xl font-heading font-bold text-deep-charcoal mb-3" data-id="element-260">
                "{testimonial.quote}"
              </h3>
              <p className="text-deep-charcoal/80 leading-relaxed" data-id="element-261">
                {testimonial.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}